import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import moment from 'moment'
import numeral from 'numeral'
import FontAwesome from 'react-fontawesome'

import AttachedFilesBox from '../Shared/AttachedFilesBox'
import Box from '../Layout/Box'
import BoxSection from '../Layout/BoxSection'
import ModalConfirmarAccion from '../Shared/ModalConfirmarAccion'
import Immutable from 'immutable'
import ModalSelectorFromList from '../Shared/ModalSelectorFromList'
import SelectorInput from '../Shared/SelectorInput'

import { uniqueArray, isAllowedToViewComponent, romanize } from '../../utils/helpers';
import { showModalConfirmarAccion ,downloadFile, showModalSelector, selectFromSelector, getParameterByName} from '../../actions/common'
import {
    registerApprovalResult,
    updateInputs,
    seleccionarAprobacion,
    crearAprobacionAdicional
} from '../../actions/tiquetesaereo'

class Aprobaciones extends Component {


    componentWillMount() {
        this.props.getParameterByName('APROBADORES_ADICIONALES')
    }    



    componentWillReceiveProps() {
        this.setState({
            aprobadores: this.props.aprobadores
        })
    }


    constructor(props) {
		super(props)
		this.state = {
            aprobador_id: null,
            aprobadores: this.props.aprobadores,
            solicitarAprobacionAdicional: false,
            aprobadorAdicional: null,
            motivoAprobacionAdicional: ''
		}
    }

    rubros = false


    aprobador_id = null


    approve = (aprobador_id, cencos) => {

        //this.rubros = true

        this.aprobador_id  = aprobador_id
        const aprobaciones = this.props.aprobadores.filter(u => u.get('id') == aprobador_id).first().get('aprobaciones')
        this.props.showModalConfirmarAccion(true, `Al hacer click en Ok, estará aprobando el cargue de ${numeral(this.getTotal(this.aprobador_id)).format('$0,0.00')} ${cencos.length > 1 ? 'entre los ' : 'al'} centro${cencos.length > 1 ? 's' : ''} de costo ${uniqueArray(cencos).join(', ') }`, () => { this.props.showModalConfirmarAccion(false); this.props.registerApprovalResult(aprobaciones, 2)})
    }


    reject = (aprobador_id) => {
        this.rubros = false;
        const aprobaciones = this.props.aprobadores.filter(u => u.get('id') == aprobador_id).first().get('aprobaciones')
        this.props.showModalConfirmarAccion(true, `¿Esta seguro que desea rechazar esta solicitud?`, () => { this.props.showModalConfirmarAccion(false); this.props.registerApprovalResult(aprobaciones, 0)})
    }



    getTotal = (aprobador_id) => {
        const aprobacion = this.props.aprobadores.filter(u => u.get('id') == aprobador_id).first().get('aprobaciones').filter(a => a.get('estado') == 2)
        return aprobacion.count() > 0 ? aprobacion.first().getIn(['cotizacione', 'cotizado']) : 0
    }

    getSolicitudPendiente = (aprobaciones) => {
        return (
            this.props.tiquetesaereo.get('estado') === 3 &&
            aprobaciones.filter(x => x.get('estado') === 1).count() > 0
        )
    }


    getSolicitudRechazada = (aprobaciones) => {
        return aprobaciones.filter(x => x.get('estado') === 0).count() == aprobaciones.count()
    }


    getSolicitudAprobadas = (aprobaciones) => {
        return (aprobaciones.filter(x => x.get('estado') === 2).count() > 0)
    }


    getSolicitudAprobadasEnRevision = (aprobaciones) => {
        return (aprobaciones.filter(x => x.get('estado') === 3).count() > 0)
    }



    getEstadoAprobacion = (index) => {
        if (index < this.props.aprobadores.count()) {
            const aprobaciones = this.props.aprobadores.getIn([index, 'aprobaciones'])
            const validado = this.props.tiquetesaereo.get('estado') > 3 || this.props.tiquetesaereo.get('estado') === 0;
            if (aprobaciones.count() > 0) {
                if (this.getSolicitudPendiente(aprobaciones)) return 1
                if (validado && this.getSolicitudRechazada(aprobaciones)) return 0
                if (validado && this.getSolicitudAprobadas(aprobaciones)) return 2
                if (this.getSolicitudAprobadasEnRevision(aprobaciones)) return 3
                return 1
            }
        }
        return 1
    }



    getTipoAprobacion = (index) => {
        if (index < this.props.aprobadores.count()) {
            const aprobaciones = this.props.aprobadores.getIn([index, 'aprobaciones'])
            return aprobaciones.count() > 0 ? aprobaciones.first().get('tipo') : 1
        }
        return 1;
    } 
    
    
    handleOpenSelectorAprobador = () => {
        const fields = [
            { id: 1, caption: 'Nombre', value: 'fullname', width: '40%' },
            { id: 2, caption: 'Cargo', value: 'cargo', width: '40%' },
            { id: 3, caption: 'Miembro', value: 'esmiembrocomite', width: '20%' }
        ];
        this.props.showModalSelector(
            'Seleccione aprobador adicional',
            fields,
            '/usuarios/aprobadores-adicionales',
            (aprobador) => {
                this.setState({ aprobadorAdicional: aprobador });
            }
        );
    }

    handleEnviarSolicitudAdicional = () => {
        const { aprobadorAdicional, motivoAprobacionAdicional } = this.state;
        if (!aprobadorAdicional || !motivoAprobacionAdicional.trim()) return;
        this.props.crearAprobacionAdicional(aprobadorAdicional, motivoAprobacionAdicional);
        this.setState({
            solicitarAprobacionAdicional: false,
            aprobadorAdicional: null,
            motivoAprobacionAdicional: ''
        });
    }


    info_aprobador_adicional = (aprobador) => {
        const { aprobadores_adicionales } = this.props;
        if (!aprobador) return null;
        if (!aprobadores_adicionales) return null;
        const aprobadorInfo = aprobadores_adicionales.find(a => a.get('USUARIO') === aprobador.get('username'));
        if (!aprobadorInfo) return null;
        return {
            cargo: aprobadorInfo.get('CARGO') || 'Sin cargo',
            esmiembrocomite: aprobadorInfo.get('MIEMBRO_COMITE') === 'SI'
        };
    }

	render() {

        const { id, tiquetesaereo, enums, aprobadores, selectedTab } = this.props
        if (!id) return null

        const adjunto = []
        tiquetesaereo.get('cotizaciones').map((x) => {

            const adjuntoId = x.get('adjunto_id');
            const fileid = x.get('adjunto_id') ? x.getIn(['adjunto', 'id']) : null
            const filename = x.get('adjunto_id') ? x.getIn(['adjunto', 'nombre']) : null


            if(adjuntoId){
                adjunto.push({fileid, filename });
            }
        })        

		return (
            <div>
                {/* Caja de aprobación adicional */}
                { tiquetesaereo.get('estado') === 3 && (
                    <BoxSection title="Aprobación adicional">
                        <div className="row">
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={this.state.solicitarAprobacionAdicional}
                                            onChange={e => this.setState({ solicitarAprobacionAdicional: e.target.checked })}
                                        />
                                        <span style={{marginLeft: '7px'}}>Solicitar aprobación adicional</span>
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-3">
                                {this.state.solicitarAprobacionAdicional && (
                                    <div className="form-group">
                                        <label className="control-label">Seleccione aprobador adicional</label>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <SelectorInput 
                                                value={this.state.aprobadorAdicional ? this.state.aprobadorAdicional.fullname : ''} 
                                                onClick={this.handleOpenSelectorAprobador}
                                                onReset={ () => this.setState({ aprobadorAdicional: null }) }
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                            {this.state.solicitarAprobacionAdicional && this.state.aprobadorAdicional && (
                                <Fragment>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label className="control-label">Cargo del aprobador:</label>
                                            <div className="form-control input-sm" style={{ background: '#f9f9f9', paddingTop: '5px' }}>
                                                {this.state.aprobadorAdicional.cargo || 'Sin cargo'}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', marginTop: 25 }}>
                                        {this.state.aprobadorAdicional.esmiembrocomite === 'SI' && (
                                            <span className="label label-success" style={{ fontSize: 13 }}>
                                                Integrantes del Comité de Rectoría
                                            </span>
                                        )}
                                    </div>
                                </Fragment>
                            )}
                        </div>
                        <div>
                            {this.state.solicitarAprobacionAdicional && this.state.aprobadorAdicional && (
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="control-label">Motivo de la solicitud adicional</label>
                                            <textarea 
                                                rows={3} 
                                                className="form-control input-sm" 
                                                value={this.state.motivoAprobacionAdicional}
                                                onChange={e => this.setState({ motivoAprobacionAdicional: e.target.value })} 
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        {this.state.solicitarAprobacionAdicional && this.state.aprobadorAdicional && (
                            <div className="row">
                                <div className="col-md-12" style={{ textAlign: 'right', paddingTop: '10px', paddingBottom: '10px' }}>
                                    <button
                                        className="btn btn-primary btn-sm"
                                        disabled={
                                            !this.state.motivoAprobacionAdicional.trim() ||
                                            !this.state.aprobadorAdicional
                                        }
                                        onClick={this.handleEnviarSolicitudAdicional}
                                    >
                                        Enviar solicitud adicional
                                    </button>
                                </div>
                            </div>
                        )}
                    </BoxSection>
                )}
                {
                    (aprobadores.count() > 0)  && aprobadores.map((a, b) => {

                        const cencos = []

                        const estado = this.getEstadoAprobacion(b)

                        const tipo_aprobacion = this.getTipoAprobacion(b);

                        const nombre_su_original = a.get('aprobaciones').filter(x => x.get('estado') === 0 || x.get('estado') === 2).count() > 0 ? a.get('aprobaciones').filter(x => x.get('estado') === 0 || x.get('estado') === 2).first().getIn(['aprobador_su', 'fullname']) : null;

                        const info_aprobador_adicional = this.info_aprobador_adicional(a);

                        return [

                            (b > 0) ? <div key={ `sep1[${b}]` } className="separator" /> : null,                            

                            <BoxSection key={ `bs1[${a.get('id')}]` } title={ 
                                <span>
                                    {tipo_aprobacion === 3 ? (
                                        <span style={{ color: '#fff', fontWeight: 600 }}>
                                            Solicitud de aprobación adicional a <strong>{ a.get('fullname') }</strong>
                                        </span>
                                    ) : (
                                        <Fragment><span>Solicitud de aprobación a <strong>{ a.get('fullname') }</strong></span></Fragment>
                                    )}
                                </span>
                             }>

                                {info_aprobador_adicional && (
                                    <div className="row">
                                        <div className="col-md-12">
                                            <span style={{ fontWeight: 500 }}>
                                                Cargo: {info_aprobador_adicional.cargo || 'Sin cargo'}
                                            </span>
                                            {info_aprobador_adicional.esmiembrocomite ? (
                                                <span className="label label-success" style={{ marginLeft: 10 }}>
                                                    Integrantes del Comité de Rectoría
                                                </span>
                                            ) : null}
                                        </div>
                                    </div>
                                )}




                                <div className="row">
                                    <div className="col-md-12">
                                        <h4>Solicitud de aprobación: { enums.aprobaciones.estados[estado] }{ estado === 1 ? '' : <span> &bull; { a.getIn(['aprobaciones' ,'0', 'fecha' ]) ? moment(a.getIn(['aprobaciones' ,'0', 'fecha' ])).format('YYYY-MM-DD HH:mm') : null }</span> }</h4>
                                    </div>
                                </div>


                                {
                                    nombre_su_original && (
                                        <div className="row">
                                            <div className="col-md-12">
                                                <span>Esta solicitud fue {`${estado === 2 ? 'aprobada' : 'rechazada'}`} por <b>{ nombre_su_original }</b></span>
                                            </div>
                                        </div>
                                    )
                                }


                                <div className="row">
                                    <div className="col-md-12">
                                        <span>Solicitada por <b>{ tiquetesaereo.getIn(['solicitante', 'fullname']) }</b></span> &bull; <span><a href={ `mailto:${tiquetesaereo.getIn(['solicitante', 'email'])}` }>{ tiquetesaereo.getIn(['solicitante', 'email']) }</a></span>
                                    </div>
                                </div>

                                <div key={ `sep2[${b}]` } className="separator" />

                                <div className="row">
                                    <div className="col-md-12">
                                        <b>Detalle:</b>
                                    </div>
                                </div>

                                <div key={ `sep3[${b}]` } className="separator" />

                                <div className="row">
                                    <div className="col-md-12">
                                        <table className="table table-bordered table-condensed table-striped">

                                            <thead>
                                                <tr>
                                                    <th style={{ width: '10%', textAlign: 'center' }}>Seleccionar</th>
                                                    <th style={{ width: '50%' }}>Aerolínea</th>
                                                    <th style={{ width: '50%' }}>Pantallazo cotización</th>
                                                    <th style={{ width: '10%' }}>Cotización</th>
                                                    <th style={{ width: '40%' }}>Distribución</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                a.get('aprobaciones').map((c, d) => {
                                                    const responsable_id = a.get('id')
                                                    const adjuntoId = c.getIn(['cotizacione', 'adjunto_id']);
                                                    const data = adjunto.find(x => x.fileid === adjuntoId);

                                                    return(
                                                    <tr key={ `tr1[${a.get('id')}][${c.get('id')}][${d}]` }>

                                                        <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '15px' }}>
                                                        {
                                                            estado === 0 || estado === 2 ? (
                                                                <Fragment>
                                                                {
                                                                    c.get('estado') == 2 && (<FontAwesome name="check" style={{ color: 'green', fontSize: '30px' }} />)
                                                                }
                                                                </Fragment>
                                                            ):(
                                                                <Fragment>
                                                                {
                                                                    c.get('estado') == 2 ? (

                                                                        <button>
                                                                            <FontAwesome name="check" style={{ color: 'green', fontSize: '30px' }} />
                                                                        </button>

                                                                    ):(
                                                                        <button style={{ width: '45px', height: '35px' }} onClick={() => this.props.seleccionarAprobacion(b, d)} ></button>
                                                                    )
                                                                }
                                                                </Fragment>

                                                            )
                                                        }
                                                        </td>

                                                        <td>{ c.getIn(['cotizacione', 'descripcion']) }</td>

                                                        {
                                                            adjuntoId ? (
                                                                <td style={{ cursor: 'pointer' }} onClick={ adjuntoId ? () => this.props.downloadFile(data.fileid, data.filename) : () => null }>
                                                                    <i className="fa fa-download"></i>
                                                                    <span style={{ marginLeft: '3px' }}>{data.filename}</span>
                                                                </td>
                                                            ) : (
                                                                <td>
                                                                    {adjuntoId ? data.filename : 'Archivo sin adjuntar'}
                                                                 </td>
                                                            )
                                                        }

                                                        <td style={{ textAlign: 'right' }}>{ numeral(c.getIn(['cotizacione', 'cotizado'])).format('$0,0.00') }</td>

                                                        <td style={{ padding: 0 }}>
                                                            <table className="table table-bordered table-condensed">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Cenco</th>
                                                                        <th>Rubro</th>
                                                                        <th>Porcentaje</th>
                                                                        <th>Valor</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>

                                                                {c.getIn(['cotizacione', 'viaje', '0', 'cencos']).map((e, f) => {

                                                                    if (e.get('responsable_id') != responsable_id && e.getIn(['pivot', 'aprobador_id']) != responsable_id) return null

                                                                    const indexCenco = cencos.findIndex(x => x == e.get('codigo'))
                                                                    if (indexCenco == -1) cencos.push(e.get('codigo'))

                                                                    return (
                                                                        <tr key={ `tr2[${a.get('id')}][${c.get('id')}][${e.get('id')}][${f}]` }>
                                                                            <td><span title={ `${e.get('descripcion')}` }>{ e.get('codigo') }</span></td>
                                                                            <td><span title={ `${e.getIn(['pivot', 'rubro', 'descripcion'])}` }>{ e.getIn(['pivot', 'rubro', 'nombre']) }</span></td>
                                                                            <td style={{ textAlign: 'right' }}>{ numeral(e.getIn(['pivot', 'porcentaje']) / 100).format('0.0%') }</td>
                                                                            <td style={{ textAlign: 'right' }}>{ numeral((e.getIn(['pivot', 'porcentaje']) / 100) * c.getIn(['cotizacione', 'cotizado'])).format('$0,0.00') }</td>
                                                                        </tr>
                                                                    )

                                                                })}

                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>

                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>


                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="control-label">Observaciones</label>
                                            <textarea
                                                rows={6}
                                                className="form-control input-sm"
                                                value={
                                                    a.getIn(['aprobaciones', 0, 'observaciones'])  || ''
                                                }
                                                onChange={
                                                    (e) => this.props.updateInputs(`aprobadores.${b}.aprobaciones.0.observaciones`, e.target.value)
                                                }
                                                disabled = { !(isAllowedToViewComponent('aprobaciones', a)) || (estado !== 1 && estado !== 3) || tiquetesaereo.get('estado') == 0 || tipo_aprobacion === 3  }
                                                />
                                        </div>
                                    </div>
                                </div>

                                <div className="separator"></div>
                                <div className="well">
                                    <p>Recuerde que puede modificar la solicitud en cualquier momento, previo a la aprobación desde la pestaña solicitud, haciendo click sobre
                                        el botón <FontAwesome name="pencil" />&nbsp;también puede volver a una versión anterior haciendo clic sobre el botón <FontAwesome name="history" />
                                        &nbsp;seleccionando la versión correspondiente. Para hacer modificaciones puede hacer click al botón de <b>Cambiar</b>.</p>
                                </div>
                                {

                                        (isAllowedToViewComponent('aprobaciones', a)) && (estado !== 2) && tiquetesaereo.get('estado') > 0 && tiquetesaereo.get('estado') < 4 && (

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div style={{ textAlign: 'right', padding: '10px 0' }}>

                                                    {tipo_aprobacion !== 3 && (
                                                        <span style={{ marginRight : '10px' }}>
                                                            <button className="btn btn-default btn-sm btn-squared" onClick={ (e) => selectedTab(e, 0)}>Cambiar</button>
                                                        </span>
                                                    )}
                                                    
                                                    <span>
                                                        <button className="btn btn-primary btn-sm btn-squared" onClick={ e => this.approve(a.get('id'), cencos)}>Aprobar</button>
                                                    </span>
                                                    <span style={{ marginLeft: '10px' }}>
                                                        <button className="btn btn-default btn-sm btn-squared" onClick={ e => this.reject(a.get('id')) }>Rechazar</button>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                    )

                                }

                            </BoxSection>
                        ]
                    })
                }

                <ModalConfirmarAccion>
                {this.rubros && (
                    <div className="row">
                        <div className="col-md-12">
                            <Box title="Selección de rubros" onModal>
                                <div className="box-content" style={{ height: '81px', overflowX: 'hidden' }}>
                                    <table className="table table-condensed">
                                        <tbody>
                                            {
                                                this.props.tiquetesaereo.getIn(['viaje', 'cencos']).filter(c => c.get('responsable_id') == this.aprobador_id).map((x, n) => {
                                                    if (x.get('rubros').count() > 0) {
                                                        const index = this.props.tiquetesaereo.getIn(['viaje', 'cencos']).findIndex(f => f.get('id') === x.get('id'));
                                                        if (index < 0) return null
                                                        return (
                                                            <tr key={ `tr[${x.get('id')}]` }>
                                                                <td style={{ width: '20px', verticalAlign: 'middle' }} ><span>{ n + 1 }</span></td>
                                                                <td style={{ width: '55%' }} ><input type="text" className="form-control input-sm" value={ x.get('descripcion') ? x.get('descripcion') : '' } disabled /></td>
                                                                <td style={{ width: '45%' }}>
                                                                    <select className="form-control input-sm" value={ Number(x.getIn(['pivot', 'rubro_id'])) || 0 } onChange={ (e) => { this.props.updateInputs(`solicitud.viaje.cencos.${index}.pivot.rubro_id`, Number(e.target.value)) } }>
                                                                        <option value={ 0 } disabled>Seleccione una opción</option>
                                                                        {x.get('rubros').map((r,j) => {
                                                                            return(
                                                                                <option key={`optr[${j}]`} value={r.get('id')}>{r.get('nombre')}</option>
                                                                            )
                                                                        })}
                                                                    </select>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </Box>
                        </div>
                    </div>
                )}
                </ModalConfirmarAccion>
                <ModalSelectorFromList />



            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        id: state.tiquetesaereo.get('id'),
        tiquetesaereo: state.tiquetesaereo.get('solicitud'),
        aprobadores: state.tiquetesaereo.get('aprobadores'),
        enums: state.common.get('enums').toJS(),
        user: state.common.get('user'),
        aprobadores_adicionales: state.common.getIn(['parametros', 'APROBADORES_ADICIONALES']),
    }
}





function mapDispatchToProps(dispatch) {
    return {
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
        registerApprovalResult: (aprobador_id, result) => dispatch(registerApprovalResult(aprobador_id, result)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        seleccionarAprobacion: (cotizacion_id, aprobador_id) => dispatch(seleccionarAprobacion(cotizacion_id, aprobador_id)),
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        crearAprobacionAdicional: (aprobador, motivo) => dispatch(crearAprobacionAdicional(aprobador, motivo)),
        getParameterByName: (param) => dispatch(getParameterByName(param)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Aprobaciones)





// WEBPACK FOOTER //
// ./src/components/TiquetesAereos/Aprobaciones.jsx